import {type Module} from 'vuex';
import actions from './actions';
import mutations from './mutations';

// state
const state: ModuleServicesState = {
    calendarOptions: null,
    bookingServices: [],
    bookingCategories: [],
    bookingCalendars: [],
    bookingInformation: null,
    bookingService: null,
    defaultAddress: null,
    bookingData: {
        services: null,
        calendarId: null,
        date: null,
        time: null,
        multiplePeople: false,
        formattedServiceIdCategory: [],
        client: {
            salutation: '',
            prename: '',
            name: '',
            email: '',
            telephone: '',
            privacy_policy_approval: 0,
            accessibility_required: 0,
            customFormElements: [],
            people: {},
            message: '',
        }
    },
};

// module
const services: Module<ModuleServicesState, RootState> = {
    namespaced: true,
    state,
    actions,
    mutations,
};

export default services;